import content from "../../content.json";
import * as classes from "./lookbook-item.module.scss";
import LookIcon from "../../icons/Look.svg";
import { lookbook } from "../../images";
import { ActionType, AppContext, ModalType } from "../../contexts/AppContext";
import { useContext, useEffect } from "react";
import Button from "../Button/Button";
import PictureNiceLoader from "../PictureNiceLoader/PictureNiceLoader";

const LookbookItem = ({
  name,
  preventClick,
  isActive,
}: {
  name: string;
  preventClick: boolean;
  isActive: boolean;
}) => {
  const { dispatch, state } = useContext(AppContext);
  const { modal } = state;
  const { name: displayName } = content.looks[name];

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === " ") {
        dispatch({
          type: ActionType.SetModal,
          value: { type: ModalType.Look, name },
        });
      }
    };
    if (isActive && !modal) {
      window.addEventListener("keydown", onKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isActive, modal]);

  return (
    <button
      className={classes.root}
      onClick={
        preventClick
          ? null
          : () => {
              dispatch({
                type: ActionType.SetModal,
                value: { type: ModalType.Look, name },
              });
            }
      }
      aria-label={`View look: ${displayName}`}
    >
      <PictureNiceLoader
        className={classes.image}
        src={lookbook[name].src}
        sources={[
          { srcSet: lookbook[name].srcSet.png, type: "image/png" },
          { srcSet: lookbook[name].srcSet.webp, type: "image/webp" },
        ]}
        alt={`Preview of look ${displayName}`}
        sizes="(min-width: 769px) 20vw, 50vw"
        hasLoadingSpinner
      />
      <div className={classes["item-name"]}>
        <span dangerouslySetInnerHTML={{ __html: displayName }}></span>
      </div>
      <Button
        className={classes.button}
        type="dumb"
        label="Look"
        icon={<LookIcon className={classes.icon as SVGElement} />}
      />
    </button>
  );
};
export default LookbookItem;
